/* One configurator and spelling model; product-specific drawing stays in renderers. */
(() => {
  const NB = window.NB;
  NB.createProductPreview = (svg, options) => {
    const necklace = (svg.closest('[data-preview-type]')?.dataset.previewType || document.body.dataset.product) === 'necklace';
    const renderer = new (necklace ? NB.Necklace : NB.Bracelet)(svg, options);
    return {
      render(source) {
        return renderer.render(necklace
          ? {name: source.names[0], font: source.font, palette: source.color}
          : source.product === 'pair'
            ? {...source, count: 1, names: [source.names[Number(svg.dataset.pairItem || 0)]]}
            : source);
      },
      destroy() { renderer.destroy(); }
    };
  };
})();
